import { Box, Typography, Link } from "@mui/material";
import {useHistory, useParams} from "react-router-dom";
import { getRouteUrl } from "../../../helpers/routing/getRouteUrl";
import { ROUTE_PAGE_HOME } from "../../../routers/routes";
import {useTranslation} from "react-i18next";
import {PAGE_APPLICATIONS} from "../../../locales/pages/namespaces";


const Step5Done = ({ requestNumber, showSuccessModal, setShowSuccessModal }) => {
    const {campaign} = useParams()
    const history = useHistory();
    const {t} = useTranslation(PAGE_APPLICATIONS)
    return (
        <>
            <Box
                sx={{
                    mt: 10,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                    gap: 2,
                    maxWidth: 600,
                    mx: "auto",
                }}
            >
                <Typography
                    sx={{
                        fontWeight: 700,
                        fontSize: 20,
                        color: "#004B88",
                        mb: 1,
                    }}
                >
                    {t("Done!")}
                </Typography>

                <Typography
                    sx={{
                        fontSize: 15,
                        color: "#004B88",
                        lineHeight: 1.6,
                    }}
                >
                    {t("The first stage of your request is complete. Please check your email for instructions for the next step.")}
                </Typography>

                <Link
                    component="button"
                    onClick={() => history.push(getRouteUrl(ROUTE_PAGE_HOME,{campaign}))}
                    sx={{
                        mt: 3,
                        fontSize: 14,
                        color: "#004B88",
                        textDecoration: "underline",
                        cursor: "pointer",
                    }}
                >
                    {t("Click here to review your request(s).")}
                </Link>
            </Box>
        </>
    );
};

export default Step5Done;
